"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _functions = require("../../util/functions.js");

require("./MorningstarRow.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faStar);

var RATING_TIME_PERIODS = ['mstarRatOverall', 'mstarRatYrs03', 'mstarRatYrs05', 'mstarRatYrs10'];
var NUM_INVESTMENTS_TIME_PERIODS = ['numberOfInvestmentsOverall', 'numberOfInvestmentsYrs03', 'numberOfInvestmentsYrs05', 'numberOfInvestmentsYrs10'];

var MorningstarRow =
/*#__PURE__*/
function (_Component) {
  _inherits(MorningstarRow, _Component);

  function MorningstarRow() {
    _classCallCheck(this, MorningstarRow);

    return _possibleConstructorReturn(this, _getPrototypeOf(MorningstarRow).apply(this, arguments));
  }

  _createClass(MorningstarRow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          fund = _this$props.fund,
          i18n = _this$props.i18n;

      if (fund.stdPerformance === null) {
        return null;
      } // Create array of year labels


      var yearLabels = [i18n.t('overall'), i18n.t('3-Year'), i18n.t('5-Year'), i18n.t('10-Year')]; // Get the URL for the fund

      var url = fund.fundPageURL ? fund.fundPageURL : 'http://performance.morningstar.com/fund/performance-return.action?t=' + fund.ticker; // Create the repeating row detail for the time periods

      var rowDetail = RATING_TIME_PERIODS.map(function (period, idx) {
        // Get the mstar icon for the given time period
        var mstarIconCurrent = _toConsumableArray(Array(fund.morningStarScorecard[0].values[fund.morningStarScorecard[0].keys.indexOf(period)])).map(function (item, index) {
          return _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
            className: "fa",
            icon: "star",
            key: index
          });
        }); // Get the number of funds in category for that time period


        var mstarNumCurrent = fund.morningStarScorecard[0].values[fund.morningStarScorecard[0].keys.indexOf(NUM_INVESTMENTS_TIME_PERIODS[idx])];
        return _react.default.createElement("tr", {
          className: (0, _classnames.default)(idx === 0 ? 'greyline' : 'no-line'),
          key: Math.random()
        }, _react.default.createElement("td", {
          width: "50",
          className: 'textLeft no-line sticky ticker'
        }, idx === 0 ? _react.default.createElement("a", {
          className: "tickerLink",
          href: url,
          target: "_new"
        }, fund.ticker) : null), _react.default.createElement("td", {
          className: 'textLeft no-line category'
        }, idx === 0 ? fund.morningStarCategory : null), _react.default.createElement("td", {
          className: (0, _classnames.default)('textLeft', 'category', 'row-name', idx === 0 ? 'whiteline' : 'greyline')
        }, yearLabels[idx]), _react.default.createElement("td", {
          className: "textCenter category"
        }, mstarIconCurrent), _react.default.createElement("td", {
          className: "textCenter category"
        }, (0, _functions.formatNumberWithCommas)(mstarNumCurrent)));
      });
      return _react.default.createElement(_react.Fragment, null, rowDetail);
    }
  }]);

  return MorningstarRow;
}(_react.Component);

MorningstarRow.propTypes = {
  /**
   * Fund object to show Morningstar data for. Should only be a WTETF...
   */
  fund: _propTypes.default.object,

  /**
   * Index of row
   */
  index: _propTypes.default.number
};
var _default = MorningstarRow;
exports.default = _default;